import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";

// InterFace
import {
  TableColumn,
  DataColumn,
  SubDataColumn,
  EditDataDifine,
} from "../../config/dataInterface";
import { getOneYearListDetail } from "../../lib/other";
import {
  DataDetailRowContractNumberMonths,
  DataDetailRowCustomerInfo,
  DataDetailRowContractInfo,
  DataDetailRowOptionSelect,
  DataDetailRowElse,
  DataDetailRowOption,
} from "./DataDetailComponent";

// api
import { getProductOptionsDependServices } from "../../api/productOption";
import { getTossUpFormOptionsDependProducts } from "../../api/tossUpFormOption";
import { getOutsideEntryFormOptionsDependServices } from "../../api/outsideEntryFormOption";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../../lib/store";
import { useWindowSize } from "../../lib/useWindowSize";

import { CONST } from "../../config/const";

interface DataDetailModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  detailTitle: string;
  editAuth: string[];
  dataColumn: DataColumn[];
  subDataColumn: SubDataColumn[];
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  setEditData: (data: EditDataDifine | null) => void;
  option: boolean;
  setEditProduct: (data: { [key: string]: any } | null) => void;
  dataDetailOption: {
    [key: string]: string | number;
  }[];
  dataDetailOptionSelect: {
    [key: string]: string;
  }[];
  dataDetailHistory: {
    selected_date: string;
    contract_version: number;
  }[];
  selectHistory: number;
  getOldDataDetail: (
    id: string,
    service_plan_id: string,
    contract_version: number
  ) => void;
  getGroupList: (id: string) => void;
  setEditProductOptionPlans: (
    value: {
      service_plan_id: number;
      service_plan_name: string;
    }[]
  ) => void;
  setEditProductOptionContents: (
    value: {
      service_content_id: number;
      service_content_name: string;
    }[]
  ) => void;
  setEditTossUpFormOptionProducts: (
    value: {
      high_rank_company_name: string;
      product_id: number;
      product_name: string;
    }[]
  ) => void;
  setEditOutsideServices: (
    value: {
      outside_entry_form_service_id: number;
      outside_entry_form_service_name: string;
    }[]
  ) => void;
  setSelectServiseInfo: (value: {
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  }) => void;
  setSelectTossUpInfo: (value: {
    tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[];
    tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[];
  }) => void;
}

export function DataDetailModal(props: DataDetailModalProps) {
  const {
    onModal,
    swCloseModal,
    detailTitle,
    editAuth,
    dataColumn,
    subDataColumn,
    dataDetail,
    setEditData,
    option,
    setEditProduct,
    dataDetailOption,
    dataDetailOptionSelect,
    dataDetailHistory,
    selectHistory,
    getOldDataDetail,
    getGroupList,
    setEditProductOptionPlans,
    setEditProductOptionContents,
    setEditTossUpFormOptionProducts,
    setEditOutsideServices,
    setSelectServiseInfo,
    setSelectTossUpInfo,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);
  const pathname = useAtomValue(AppAtoms.pathname);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [lastContractVersion, setLastContractVersion] = useState<number>(0);
  useEffect(() => {
    if (dataDetailHistory.length === 0) return;
    const last_contract_version = dataDetailHistory.reduce(
      (max, item) =>
        item.contract_version > max ? item.contract_version : max,
      dataDetailHistory[0].contract_version
    );
    setLastContractVersion(last_contract_version);
  }, [dataDetailHistory]);
  return dataDetail ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
            display:
              (option || dataDetailHistory.length > 0) && windowWidth > 469
                ? "flex"
                : undefined,
            height:
              (option || dataDetailHistory.length > 0) && windowWidth < 470
                ? "50px"
                : undefined,
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          {detailTitle}
          {dataDetailHistory.length > 0 ? (
            <Box
              sx={{
                position: "absolute",
                right: "35px",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  marginLeft: "30px",
                  marginTop: "8px",
                  width: "80px",
                  fontSize: "16px",
                  color: "rgb(50 50 50)",
                }}
                className="shippori-antique-regular"
              >
                更新履歴
              </Box>
              <FormControl sx={{ width: "160px", marginTop: "5px" }}>
                <Select
                  labelId="serch-input-label"
                  id="serch-input"
                  value={selectHistory}
                  onChange={(e) => {
                    getOldDataDetail(
                      dataDetail.id as string,
                      dataDetail.service_id as string,
                      e.target.value as number
                    );
                  }}
                  sx={{
                    height: "30px",
                    textAlign: "end",
                    fontSize: "14px",
                  }}
                >
                  {dataDetailHistory.map((history, i) => {
                    return (
                      <MenuItem
                        key={"komokuTypeRireki" + i}
                        value={history.contract_version}
                        sx={{
                          textAlign: "right",
                          height: "30px",
                          fontSize: "14px",
                        }}
                      >
                        {history.selected_date}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          ) : null}
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          <Box
            sx={{
              maxHeight:
                (option || dataDetailHistory.length > 0) && windowWidth < 470
                  ? option
                    ? "calc(70vh - 150px)"
                    : "calc(70vh - 120px)"
                  : "calc(70vh - 80px)",
              overflowY: option ? "auto" : undefined,
            }}
          >
            {!option ? (
              <TableContainer
                component={Paper}
                sx={{
                  margin: "1px 1px",
                  width: "calc(100% - 4px)",
                  maxHeight:
                    (option || dataDetailHistory.length > 0) &&
                    windowWidth < 470
                      ? "calc(70vh - 120px)"
                      : "calc(70vh - 80px)",
                  border: "1px solid rgb(230, 230, 230)",
                }}
              >
                <Table stickyHeader size="small" aria-label="collapsible table">
                  <TableHead>
                    <TableRow key="detaiTableRow">
                      <TableCell
                        key={"tableColumnKomoku"}
                        align="center"
                        sx={{
                          width: "30%",
                          minWidth: "150px",
                          backgroundColor: CONST.tableDetailsBackgroundColor,
                        }}
                      >
                        <Box className="table-header">質問名</Box>
                      </TableCell>
                      <TableCell
                        key={"tableColumnShosai"}
                        align="center"
                        sx={{
                          width: "60%",
                          minWidth: "200px",
                          backgroundColor: CONST.tableDetailsBackgroundColor,
                        }}
                      >
                        <Box className="table-header">詳細</Box>
                      </TableCell>
                      {loginUser?.authority &&
                      editAuth.findIndex(
                        (authority) => authority === loginUser.authority
                      ) > -1 &&
                      ((pathname == "/toss_up" &&
                        dataDetail["disable_change"] === 1) ||
                        pathname != "/toss_up") &&
                      ((dataDetailHistory.length > 0 &&
                        dataDetail.contract_version === lastContractVersion) ||
                        dataDetailHistory.length === 0) ? (
                        <TableCell
                          key={"tableColumnEdit"}
                          align="center"
                          sx={{
                            width: "10%",
                            minWidth: "30px",
                            backgroundColor: CONST.tableDetailsBackgroundColor,
                          }}
                        >
                          <Box className="table-header">編集</Box>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataColumn.map((dataColumn, i) => {
                      if (dataColumn.detail) {
                        if (dataColumn.key === "contract_number_months") {
                          return getOneYearListDetail().map(
                            (yearMonth, year_i) => {
                              return (
                                <DataDetailRowContractNumberMonths
                                  editAuth={editAuth}
                                  dataColumn={dataColumn}
                                  dataDetail={dataDetail}
                                  dataDetailHistory={dataDetailHistory}
                                  lastContractVersion={lastContractVersion}
                                  year_i={year_i}
                                  yearMonth={yearMonth}
                                  detailType="datail"
                                />
                              );
                            }
                          );
                        } else if (dataColumn.key === "customer_info") {
                          return dataDetailOption.map(
                            (
                              {
                                option_id,
                                option_name,
                                option_type,
                                tel_flg,
                                name_flg,
                                company_name_flg,
                                half_width_number_flg,
                                multi_text_flg,
                                entry_method,
                              },
                              option_i
                            ) => {
                              const customer_info =
                                dataDetail.customer_info as {
                                  [key: string]: string | string[];
                                };
                              const optionValue = customer_info[option_name];
                              return (
                                <DataDetailRowCustomerInfo
                                  editAuth={editAuth}
                                  dataColumn={dataColumn}
                                  dataDetail={dataDetail}
                                  dataDetailHistory={dataDetailHistory}
                                  lastContractVersion={lastContractVersion}
                                  setEditData={setEditData}
                                  option_i={option_i}
                                  option_id={option_id}
                                  option_name={option_name}
                                  option_type={option_type}
                                  tel_flg={tel_flg}
                                  name_flg={name_flg}
                                  company_name_flg={company_name_flg}
                                  half_width_number_flg={half_width_number_flg}
                                  multi_text_flg={multi_text_flg}
                                  entry_method={entry_method}
                                  optionValue={optionValue}
                                  customer_info={customer_info}
                                  detailType="datail"
                                />
                              );
                            }
                          );
                        } else if (dataColumn.key === "option_select") {
                          return dataDetailOptionSelect.map(
                            (optionSelect, key_i) => {
                              return (
                                <DataDetailRowOptionSelect
                                  optionSelect={optionSelect}
                                  key_i={key_i}
                                />
                              );
                            }
                          );
                        } else if (
                          ((dataColumn.key === "closing_memo" &&
                            (dataDetail["toss_up_status"] ===
                              "クロージング-成功" ||
                              dataDetail["toss_up_status"] ===
                                "クロージング-成功（未エントリー）")) ||
                            dataColumn.key !== "closing_memo") &&
                          ((dataColumn.key === "closing_failed_memo" &&
                            dataDetail["toss_up_status"] ===
                              "クロージング-失敗") ||
                            dataColumn.key !== "closing_failed_memo") &&
                          ((dataColumn.key === "return_call_memo" &&
                            (dataDetail["toss_up_status"] === "不出" ||
                              dataDetail["toss_up_status"] === "時節" ||
                              dataDetail["toss_up_status"] === "見込み")) ||
                            dataColumn.key !== "return_call_memo") &&
                          ((dataColumn.key === "sns_send_flg" &&
                            (dataDetail["service_type"] === 'キャンペーン（プルダウン）' ||
                              dataDetail["service_type"] === 'キャンペーン（チェックボックス）')) ||
                            dataColumn.key !== "sns_send_flg")
                        ) {
                          if (
                            loginUser &&
                            dataColumn.tableDetailAuth.includes(
                              loginUser.authority
                            )
                          ) {
                            return (
                              <DataDetailRowElse
                                editAuth={editAuth}
                                dataDetail={dataDetail}
                                dataDetailHistory={dataDetailHistory}
                                lastContractVersion={lastContractVersion}
                                setEditData={setEditData}
                                i={i}
                                dataColumnName={dataColumn.name}
                                dataColumnKey={dataColumn.key}
                                dataColumnEdit={dataColumn.edit}
                                dataColumnEditType={
                                  dataColumn.editType === "outside_site_logo"
                                    ? "outside_site_logo"
                                    : dataColumn.editType ===
                                      "outside_site_favicon"
                                    ? "outside_site_favicon"
                                    : dataColumn.editType === "list"
                                    ? "list"
                                    : dataColumn.editType === "multitext"
                                    ? "multitext"
                                    : dataColumn.editType === "screen_column"
                                    ? "screen_column"
                                    : dataColumn.editType === "entry_info"
                                    ? "entry_info"
                                    : dataColumn.editType === "toss_up_info"
                                    ? "toss_up_info"
                                    : "text"
                                }
                                dataColumnEditId={dataColumn.editId}
                                detailTitle={detailTitle}
                                dataColumnTableValue={dataColumn.tableValue}
                                getGroupList={getGroupList}
                                detailType="datail"
                                setSelectServiseInfo={setSelectServiseInfo}
                                setSelectTossUpInfo={setSelectTossUpInfo}
                              />
                            );
                          }
                        }
                      }
                    })}
                    {subDataColumn.map((dataColumn, i) => {
                      if (dataColumn.detail) {
                        if (dataColumn.key === "option_select") {
                          return dataDetailOptionSelect.map(
                            (optionSelect, key_i) => {
                              return (
                                <DataDetailRowOptionSelect
                                  optionSelect={optionSelect}
                                  key_i={key_i}
                                />
                              );
                            }
                          );
                        } else {
                          return (
                            <DataDetailRowElse
                              editAuth={editAuth}
                              dataDetail={dataDetail}
                              dataDetailHistory={dataDetailHistory}
                              lastContractVersion={lastContractVersion}
                              setEditData={setEditData}
                              i={i}
                              dataColumnName={dataColumn.name}
                              dataColumnKey={dataColumn.key}
                              dataColumnEdit={dataColumn.edit}
                              dataColumnEditType={
                                dataColumn.editType === "site_pdf_path"
                                  ? "site_pdf_path"
                                  : dataColumn.editType === "list"
                                  ? "list"
                                  : dataColumn.editType === "multitext"
                                  ? "multitext"
                                  : "text"
                              }
                              dataColumnEditId={dataColumn.editId}
                              detailTitle={detailTitle}
                              dataColumnTableValue={dataColumn.tableValue}
                              getGroupList={getGroupList}
                              detailType="datail"
                              setSelectServiseInfo={setSelectServiseInfo}
                              setSelectTossUpInfo={setSelectTossUpInfo}
                            />
                          );
                        }
                      }
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              (
                dataDetail.option_data as {
                  [key: string]: string | number | string[];
                }[]
              ).map((uniqueOption, option_i) => {
                const option_selects = uniqueOption.option_select as any[];
                return (
                  <DataDetailRowOption
                    option_i={option_i}
                    uniqueOption={uniqueOption}
                    option_selects={option_selects}
                  />
                );
              })
            )}
          </Box>
          <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
            {option &&
            (loginUser?.authority === "マスターアカウント" ||
              loginUser?.authority === "スタッフアカウント") ? (
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={async () => {
                    setIsLoading(true);
                    setEditProduct({
                      status: "editing",
                    });
                    let product_key = "1";
                    let product_contract_number = "0";
                    if (pathname === "/entry_form") {
                      const productId = dataDetail.product_id as string;
                      const {
                        service_plan_data,
                        service_content_data,
                        fetch_product_key,
                        fetch_product_contract_number,
                      } = await getProductOptionsDependServices(productId);
                      setEditProductOptionPlans(service_plan_data);
                      setEditProductOptionContents(service_content_data);
                      product_key = fetch_product_key;
                      product_contract_number =
                        fetch_product_contract_number ?? "0";
                    }
                    if (pathname === "/toss_up_form") {
                      const category_id = dataDetail.category_id as string;
                      const { product_data } =
                        await getTossUpFormOptionsDependProducts(category_id);
                      setEditTossUpFormOptionProducts(product_data);
                    }
                    if (pathname === "/outside_entry_form") {
                      const outside_entry_form_id =
                        dataDetail.outside_entry_form_id as string;
                      const { outside_service_data, fetch_product_key } =
                        await getOutsideEntryFormOptionsDependServices(
                          outside_entry_form_id
                        );
                      setEditOutsideServices(outside_service_data);
                      product_key = fetch_product_key;
                    }
                    if (
                      (
                        dataDetail.option_data as {
                          [key: string]: string | number | string[];
                        }[]
                      ).length == 0
                    ) {
                      setEditProduct({
                        // 共通
                        status: "before",
                        select_option_index: null,
                        select_option: null,
                        add_select_option_flg: false,
                        tableId: dataDetail.id as number,
                        delete_option: [],
                        product_option: [],
                        product_key: product_key,
                        product_contract_number: product_contract_number,
                        // エントリーフォーム
                        product_name: dataDetail.product_name,
                        entry_form_id: dataDetail.entry_form_id,
                        entry_sale_company_name:
                          dataDetail.entry_sale_company_name,
                        // トスアップフォーム
                        category_name: dataDetail.category_name,
                        toss_up_form_id: dataDetail.toss_up_form_id,
                        toss_up_company_name: dataDetail.toss_up_company_name,
                        // 外部エントリーフォーム
                        outside_entry_form_id: dataDetail.outside_entry_form_id,
                      });
                    } else {
                      setEditProduct({
                        status: "before",
                        select_option_index: null,
                        select_option: null,
                        add_select_option_flg: false,
                        tableId: dataDetail.id as number,
                        product_option: dataDetail.option_data,
                        delete_option: [],
                        product_key: product_key,
                        product_contract_number: product_contract_number,
                        // エントリーフォーム
                        product_name: dataDetail.product_name,
                        entry_form_id: dataDetail.entry_form_id,
                        entry_sale_company_name:
                          dataDetail.entry_sale_company_name,
                        // トスアップフォーム
                        category_name: dataDetail.category_name,
                        toss_up_form_id: dataDetail.toss_up_form_id,
                        toss_up_company_name: dataDetail.toss_up_company_name,
                        // 外部エントリーフォーム
                        outside_entry_form_id: dataDetail.outside_entry_form_id,
                      });
                    }
                    setIsLoading(false);
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">質問一覧編集</Box>
                </Button>
              </Box>
            ) : null}
            <Box
              style={{
                marginTop: "10px",
                height: "40px",
                width:
                  windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                marginLeft:
                  windowWidth > 385
                    ? !option
                      ? "calc(50% + 10px)"
                      : "10px"
                    : "5px",
              }}
            >
              <Button
                variant="contained"
                style={{
                  height: "40px",
                  width: "100%",
                  textTransform: "none",
                }}
                onClick={swCloseModal}
              >
                <Box className="m-plus-rounded-1c-regular">閉じる</Box>
              </Button>
            </Box>
          </Box>
        </Typography>
      </Box>
    </Modal>
  ) : null;
}
